import { render, staticRenderFns } from "./coreSelect.vue?vue&type=template&id=5da903da&scoped=true&"
import script from "./coreSelect.vue?vue&type=script&lang=js&"
export * from "./coreSelect.vue?vue&type=script&lang=js&"
import style0 from "./coreSelect.vue?vue&type=style&index=0&id=5da903da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5da903da",
  null
  
)

export default component.exports